<template>
  <v-card width="100%" class="rounded-xl" id="archived">
    <v-toolbar color="secondary">
      <v-toolbar-title>
        <v-icon class="mr-2">mdi-check-all</v-icon>
        Completed Cases
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="extended = !extended">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar>
    <CaseSearch v-model="caseFilter" :extended="extended" color="secondary" />
    <v-card-text>
      <v-card class="overflow-y-auto" flat max-height="600">
        <div
          class="ma-0 py-1"
          v-for="(kase, index) in filteredArchivedCases"
          :key="index"
        >
          <v-lazy>
            <CaseCard :kase="kase" />
          </v-lazy>
        </div>
      </v-card>
      <div v-if="filteredArchivedCases.length === 0" class="text-center my-5">
        <v-icon>mdi-sleep</v-icon>
        <br />
        No cases found...
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CaseCard from "@/components/shared/CaseCard";
import CaseSearch from "@/components/shared/CaseSearch";

export default {
  name: "ArchivedCases",
  components: {
    CaseCard,
    CaseSearch,
  },
  data() {
    return {
      caseFilter: "",
      extended: false,
    };
  },
  computed: {
    ...mapGetters(["archivedCases"]),
    filteredArchivedCases() {
      if (!this.caseFilter) {
        return this.archivedCases;
      }
      return this.archivedCases.filter((archivedCase) => {
        return (
          `${archivedCase.collection_id}`.includes(this.caseFilter) ||
          archivedCase.patient_reference
            .toLowerCase()
            .includes(this.caseFilter.toLowerCase())
        );
      });
    },
  },
};
</script>
